export default "__VITE_ASSET__CxsPKsZJ__"